import React from 'react';
import {
    Alert,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';

/**
 * Confirmation dialog for restoring a historical report version.
 */
export default function RestoreVersionDialog({
    open,
    version,
    restoring,
    error,
    onClose,
    onConfirm,
}) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Restore version {version}?</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    This will replace the current report content with version {version} and save it as a new
                    version. Collaborators with the editor open will be disconnected and need to reload.
                </DialogContentText>
                {error && (
                    <Alert severity="error" sx={{mt: 2}}>
                        {error}
                    </Alert>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={restoring}>
                    Cancel
                </Button>
                <Button onClick={onConfirm} color="warning" variant="contained" disabled={restoring}>
                    {restoring ? 'Restoring…' : 'Restore'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
